import { PublicLayout } from 'components/Layout';
import React from 'react';
import { LicenseContainer } from '../../Shared/LicenseInfo';

export const LicenseComponent = () => {
  return (
    <PublicLayout mainClasses="page">
      <LicenseContainer />
    </PublicLayout>
  );
};
